import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';

import { registerReferralSharingEvent } from 'ggApp/modules/gaAnalytics/actions';
import { storeActive as activeStoreSelector } from 'ggApp/modules/store/selectors';
import { keys, translate } from 'ggApp/modules/translator/selectors';

import SocialSharingList from './SocialSharingList';

const enhance = compose(
    connect(
        createStructuredSelector({
            activeStore: activeStoreSelector,
            translationKeys: keys,
        }),
        (dispatch) => ({
            registerReferralSharingEvent: bindActionCreators(
                registerReferralSharingEvent,
                dispatch,
            ),
        }),
    ),
    withProps(({ translationKeys, activeStore }) => ({
        copyCtaText: translate(translationKeys, activeStore.activeLanguage, 'REFERRALS_COPY_LINK'),
    })),
);
export default enhance(SocialSharingList);
